<template>
    <el-popover
        :title="title"
        :width="width"
        :placement="placement"
        :trigger="trigger"
        :content="content">
      <slot/>
    <i class="el-icon-question" style="color:#909399" slot="reference"></i>
  </el-popover>
</template>

<script>
export default {
  name: 'h-tip',
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 200
    },
    content: {},
    trigger: {
      type: String,
      default: 'hover'
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tip.vue